import _default from './Divider';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Divider/index.js
// module id = 952
// module chunks = 0